export default "/fonts/Acrom-Regular.woff?df8e499028de083bc8876f6ff991c5a1";